module.exports = fox._r("owl-carousel2/dist/assets/owl.video.play.png", __webpack_public_path__ + "_/_/_/_/_/bower_components/owl-carousel2/dist/assets/owl.video.play.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/bower_components/owl-carousel2/dist/assets/owl.video.play.png
// module id = 207
// module chunks = 5